<template>
  <div class="row">
    <transition name="fade-right">
      <div v-show="mediumResImagesLoaded < portfolioImages.length" class="high-res-images-loader">
        <div class="value">
          <span>{{ mediumResImagesLoaded }}/{{ portfolioImages.length }}</span>
          <span>OF IMAGES</span>
          <span>{{
            Math.round(
              (mediumResImagesLoaded / portfolioImages.length) * 100
            )
          }}%</span>
        </div>
      </div>
    </transition>

    <div data-scroll-container class="col-16 align-items-start">
      <div data-scroll-section class="row no-gutters align-items-lg-start align-items-end w-100">
        <div class="col-xxl-15">
          <button type="button" class="btn-change-view ml-auto mt-xxl-0 mt-lg-5" @click="toggleMasonryColumns">change view</button>
        </div>

        <div class="col-xxl-15 mt-5">
          <div class="masonry" :class="[`columns-${masonryColumns}`, { active: showMasonry }]">
            <a data-fancybox="gallery" :data-caption="image.high.title" v-for="(image, index) in portfolioImages" :key="index" class="masonry-item" :href="$root.viewport.width > 992 ? image.high.src : image.medium" :style="{ 'grid-row-end': `span ${image.low.height}` }">
              <img :data-src="image.medium" class="img-medium" @load="showMediumResImage" />
              <div class="img-loader"></div>
              <img :src="image.low.src" class="img-low" @load="onLowResImageLoad" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImagesListingMixin from "../images-listing-mixin.js";

// import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import { Fancybox } from "@fancyapps/ui";
import galleryOptions from "../imports/fancyOptions";
Fancybox.bind("[data-fancybox]", galleryOptions);

export default {
  mixins: [ImagesListingMixin("portfolio")],
  computed: {
    masonryColumns() {
      const columnsByWidth = {
        '576': 1,
        '1200': 2,
        '1367': 3,
      };

      const columnsByWidthAlt = {
        '576': 2,
        '1200': 3,
        '1367': 4,
      };

      const columns = this.masonryView === "default" ? columnsByWidth : columnsByWidthAlt;

      let key = 1367;

      if (this.$root.viewport.width < 1200) {
        key = 1200;
      }

      if (this.$root.viewport.width < 576) {
        key = 576;
      }

      return columns[key];
    },
  }
};
</script>

<style lang="scss">
// @import "src/sass/variables";
// @import "src/sass/mixins";
// @import "node_modules/bootstrap/scss/vendor/rfs";
// portfolio-menu</style>